export const SUCROSE_PAC_MULTIPLIER = 1;
export const GLUCOSE_PAC_MULTIPLIER = 1.9;
export const FRUCTOSE_PAC_MULTIPLIER = 1.9;
export const LACTOSE_PAC_MULTIPLIER = 1;
export const MALTOSE_PAC_MULTIPLIER = 1;
export const GALACTOSE_PAC_MULTIPLIER = 1.9;
// NaCl dissociates into two ions, so its colligative effect is roughly doubled.
// A measured van't Hoff factor is about 1.9 particles per NaCl formula unit:
// https://openstax.org/books/chemistry/pages/11-4-colligative-properties#fs-idp191832160
export const SALT_PAC_MULTIPLIER = 11.13;
export const ALCOHOL_PAC_MULTIPLIER = 7.4;

export function calculatePAC({
  sucrose = 0,
  glucose = 0,
  fructose = 0,
  lactose = 0,
  maltose = 0,
  galactose = 0,
  salt = 0,
  alcohol = 0,
}: Partial<{
  sucrose: number;
  glucose: number;
  fructose: number;
  lactose: number;
  maltose: number;
  galactose: number;
  salt: number;
  alcohol: number;
}>): number {
  const sucrosePAC = sucrose * SUCROSE_PAC_MULTIPLIER;
  const glucosePAC = glucose * GLUCOSE_PAC_MULTIPLIER;
  const fructosePAC = fructose * FRUCTOSE_PAC_MULTIPLIER;
  const lactosePAC = lactose * LACTOSE_PAC_MULTIPLIER;
  const maltosePAC = maltose * MALTOSE_PAC_MULTIPLIER;
  const galactosePAC = galactose * GALACTOSE_PAC_MULTIPLIER;
  const saltPAC = salt * SALT_PAC_MULTIPLIER;
  const alcoholPAC = alcohol * ALCOHOL_PAC_MULTIPLIER;

  return (
    sucrosePAC +
    glucosePAC +
    fructosePAC +
    lactosePAC +
    maltosePAC +
    galactosePAC +
    saltPAC +
    alcoholPAC
  );
}
